<route>
{
  "meta": {
    "permission": [
      "notifications.view_notification"
    ]
  }
}
</route>

<template>
  <v-container fluid>
    <i-table
      :title="$t('notifications_events')"
      :headers="headers"
      app="events.event"
      api="event"
      :opt="{ mode: 'list' }"
      dontCreate
      dontEdit
    >
      <template v-slot:item.background="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <i-btn :color="item.background" v-on="on" :title="item.background">
            </i-btn>
          </template>
        </v-tooltip>
      </template>
    </i-table>
  </v-container>
</template>
<script>
export default {
  computed: {
    headers() {
      return [
        {
          text: this.$t('section_only'),
          value: 'app_label'
        },
        {
          text: this.$t('section_sub'),
          value: 'model'
        },
        {
          text: this.$tc('color', 1),
          value: 'background'
        },
        {
          text: this.$t('title'),
          value: 'title'
        },
        {
          text: this.$t('detail'),
          value: 'details'
        },
        {
          text: this.$t('date'),
          value: 'date'
        },
        {
          text: this.$t('code'),
          value: 'code'
        },
        {
          text: this.$t('action'),
          value: 'actions'
        }
      ]
    }
  }
}
</script>
